import React, { useState } from "react";
import Header from "./Header";
import Loader from "./Loader.js";
import ReservationCalendar from "./ReservationCalendar";
import ReservationHistory from "./ReservationHistory";
import { goBack } from "../CommonJquery/CommonJquery.js";
import { Button } from '@mui/material';
import { ArrowLeft } from 'lucide-react';
function ViewReservationCalendar() {
  const [calendarTab, setCalendarTab] = useState(false);
  const [historyTab, setHistoryTab] = useState(true);

  const toggleTabs = (Tab) => {
    // if (Tab === "Calender") {
    //   window.location.reload();
    // }
    setCalendarTab(Tab === "Calender");
    setHistoryTab(Tab === "History");
  };

  const [sharedValue, setSharedValue] = useState(null);

  const updateSharedValue = (value) => {
    setSharedValue(value);
    setHistoryTab("History");
    setCalendarTab(false);
  };

  return (
    <div className="dashboard">
      <div className="dashboard_container">
        <div className="page_content">
          <div className="page_content_container">
            <Header />
            <div className="pageCntn_head">
              <div className="calendertabs">
                <div className="calendertabs_container">
                  {" "}
                  <div
                    className={`calendertabsBtn ${historyTab ? "activeCalendarTab" : ""
                      }`}
                    onClick={() => toggleTabs("History")}
                  >
                    <p>Bookings</p>
                  </div>
                  {/* <div
                    className={`calendertabsBtn ${calendarTab ? "activeCalendarTab" : ""
                      }`}
                    onClick={() => toggleTabs("Calender")}
                  >
                    <p>Calendar</p>
                  </div> */}
                </div>
              </div>
              <Button
                onClick={goBack}
                startIcon={<ArrowLeft size={17} style={{ marginBottom: "2px" }} />}
                className="Back_bttn_page"
              >
                Back
              </Button>
            </div>

            <div className="page_body px-2 py-1">
              {" "}
              {historyTab && <ReservationHistory sharedValue={sharedValue} />}
              {calendarTab && (
                <ReservationCalendar updateSharedValue={updateSharedValue} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewReservationCalendar;
